/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const moment = require('moment-timezone');
const ApproverList = require('../approver/approver_list').default;
const { OrganizationBase } = require('../organization_base/organization_base');
const { ExicCard } = require('../exic_card');
const { Teiki } = require('../teiki');
const { UserForwardedEmails } = require('../user_forwarded_emails');
const RemittanceDestinationAccount = require('../expenses/remittance_destination_account').default;

class User {
  constructor(args) {
    if (args == null) {
      args = {};
    }
    _.assign(this, args);
    this.organizationId = args.organization_id;
    if (args.birthday) {
      this.birthdayMoment = moment(this.birthday);
    }
    if (!this.birthday) {
      this.birthday = '';
    }
    this.nationalizedTel = args.nationalizedTel || args.nationalized_tel;
    if (!_.isUndefined(args.department) && !_.isEmpty(args.department)) {
      if (typeof args.department.approvers !== 'undefined') {
        const approvers = _.sortBy(args.department.approvers, 'approve_stage');
        this.department_approvers = new ApproverList(approvers);
      }
    }
    if (this.teiki) {
      this.teiki = new Teiki(this.teiki);
    }
    if (args.organization_base) {
      this.organizationBase = new OrganizationBase(args.organization_base);
    }
    if (args.exic_card) {
      this.exicCard = new ExicCard(args.exic_card);
    }
    this.organizationRoleId = args.organization_role_id;
    this.gradeId = args.grade_id;
    this.exicCardId = args.exic_card_id;
    this.businessEkinetAccountId = args.business_ekinet_account_id;
    this.hotelPriceLimit = args.hotel_price_limit;
    this.foreignHotelPriceLimit = args.foreign_hotel_price_limit;
    this.defaultSeatClasses = args.default_seat_classes || [];

    this.firstName = args.first_name;
    this.lastName = args.last_name;
    this.firstNameRoman = args.first_name_roman;
    this.lastNameRoman = args.last_name_roman;
    this.firstNameKana = args.first_name_kana;
    this.lastNameKana = args.last_name_kana;
    this.mileageNumbers = args.mileage_numbers;
    this.browsingDepartments = args.browsing_departments;
    this.signInMethod = args.sign_in_method;
    this.exicId = args.exic_id || '';
    this.exicPassword = args.exic_password || '';
    this.passportNumber = args.passport_number;
    this.passportExpire = args.passport_expire;

    this.adminNotification = args.admin_notification;
    this.isOrganizationAdmin = args.is_organization_admin;
    this.aicalendarAvailable = args.aicalendar_available;
    this.aicalendarAdmin = args.aicalendar_admin;
    this.nationalities = args.nationalities;
    this.nationalityId = args.nationality_id;
    this.ignoreIpAddressRestriction = args.ignore_ip_address_restriction;
    this.aiTravelSlackToken = args.ai_travel_slack_token;
    this.expensesSlackConnected = args.expenses_slack_connected || false;
    this.useChatbot = args.use_chatbot || false;
    this.useSlackApp = args.use_slack_app || false;
    this.supportAccount = args.support_account || false;
    if (!args.user_forwarded_emails || args.user_forwarded_emails.length === 0) {
      this.userForwardedEmails = [new UserForwardedEmails({ email: '' })];
    } else {
      this.userForwardedEmails = _.map(args.user_forwarded_emails, e => new UserForwardedEmails(e));
    }

    this.remittanceDestinationAccount = (() => {
      if (args.remittance_destination_account) {
        return new RemittanceDestinationAccount(args.remittance_destination_account);
      } else if (args.needAccount) {
        return RemittanceDestinationAccount.build();
      }
    })();

    this.disabled = args.disabled;
    this.reservationAccepted = typeof args.reservation_accepted !== 'undefined' ? args.reservation_accepted : true;
    this.hasImportantOrganizationInformation = !!args.has_important_organization_information;
    this.needAppointDashboardCoachMark = args.need_appoint_dashboard_coach_mark;
    this.acceptedChatbotTerms = args.accepted_chatbot_terms;
    this.domesticAirSeatUpgrade = args.domestic_air_seat_upgrade;
    this.exicReferenceNumber = args.exic_reference_number || '';
    this.browsingScope = args.browsing_scope;
    this.autoSyncTripToCalendar =
      typeof args.auto_sync_trip_to_calendar !== 'undefined' ? args.auto_sync_trip_to_calendar : false;
  }

  organizationRoleName(organizationRoles) {
    for (var role of Array.from(organizationRoles)) {
      if (role.id === this.organizationRoleId) {
        return role.name;
      }
    }
  }

  gradeName(grades) {
    for (var grade of Array.from(grades)) {
      if (String(grade.id) === this.gradeId) {
        return grade.name;
      }
    }
  }

  nameRoman() {
    return `${this.last_name_roman} ${this.first_name_roman}`;
  }

  nameKana() {
    return `${this.last_name_kana || ''} ${this.first_name_kana || ''}`;
  }

  organizationBaseId() {
    return dig(this, 'organizationBase', 'id');
  }

  organizationBaseName() {
    return dig(this, 'organizationBase', 'name');
  }

  departmentId() {
    return dig(this, 'department', 'id');
  }

  departmentName() {
    return dig(this, 'department', 'name');
  }

  approver() {
    return dig(this, 'department', 'approvers', 0);
  }

  approverName() {
    return dig(this, 'department', 'approvers', 0, 'name');
  }

  approvers() {
    return dig(this, 'department', 'approvers');
  }

  approverNames() {
    if (this.approvers()) {
      return _.map(this.approvers(), a => a.name);
    } else {
      return ['-'];
    }
  }

  hasOrganizationBase() {
    return !_.isNil(this.organizationBase);
  }

  isMember() {
    return !_.isNil(this.organizationId);
  }

  emailAndName() {
    return this.name + '(' + this.email + ')';
  }

  setEmployeeNumber(value) {
    this.employee_number = value;
    return app.render();
  }

  setLastName(value) {
    this.last_name = value;
    this.lastName = value;
    this.name = `${this.last_name} ${this.first_name}`;
    return app.render();
  }

  setFirstName(value) {
    this.first_name = value;
    this.firstName = value;
    this.name = `${this.last_name} ${this.first_name}`;
    return app.render();
  }

  setLastNameRoman(value) {
    this.last_name_roman = value;
    this.lastNameRoman = value;
    return app.render();
  }

  setFirstNameRoman(value) {
    this.first_name_roman = value;
    this.firstNameRoman = value;
    return app.render();
  }

  setLastNameKana(value) {
    this.last_name_kana = value;
    this.lastNameKana = value;
    return app.render();
  }

  setFirstNameKana(value) {
    this.first_name_kana = value;
    this.firstNameKana = value;
    return app.render();
  }

  setGender(value) {
    this.gender = value;
    return app.render();
  }

  setBirthday(value) {
    this.birthday = value;
    return app.render();
  }

  setBirthdayMoment(value) {
    this.birthdayMoment = value;
    if (value) {
      this.birthday = value.format('YYYY-MM-DD');
    }
    return app.render();
  }

  setEmail(value) {
    this.email = value;
    return app.render();
  }

  setPassword(value) {
    this.password = value;
    return app.render();
  }

  setTel(value) {
    this.tel = value;
    return app.render();
  }

  setDomesticApprovalRequired(value) {
    this.domestic_approval_required = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setForeignApprovalRequired(value) {
    this.foreign_approval_required = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setDomesticNotificationRequired(value) {
    this.domestic_notification_required = value === true;
    return app.render();
  }

  setForeignNotificationRequires(value) {
    this.foreign_notification_requires = value === true;
    return app.render();
  }

  setAdminNotification(value) {
    this.adminNotification = parseInt(value, 10) || 0;
    return app.render();
  }

  setNationalityId(value) {
    this.nationalityId = value;
    this.nationality_id = value;
    return app.render();
  }

  setUserForwardedEmails(value, i) {
    this.userForwardedEmails[i].email = value;
    return app.render();
  }

  setNeedAppointDashboardCoachMark(value) {
    this.needAppointDashboardCoachMark = value;
    return app.render();
  }

  filterNationalities(nationality) {
    return _.filter(nationality, n => {
      return !_.includes(this.nationalities(n.id));
    });
  }

  approvalRequired(is_foreign) {
    if (is_foreign === undefined) {
      return this.foreign_approval_required || this.domestic_approval_required;
    } else {
      return (is_foreign && this.foreign_approval_required) || (!is_foreign && this.domestic_approval_required);
    }
  }

  organizationError() {
    return _.isNil(this.approver());
  }

  inAdvanceOrganizationError(is_foreign) {
    // 海外出張の場合は、承認者が設定されていなくてもデフォルトのワークフローを使用する
    if (is_foreign) {
      return false;
    }

    // 国内出張の場合は、従来通りの挙動で、承認者がいないとエラーとする
    return this.approvalRequired(is_foreign) && this.organizationError();
  }

  setOrganizationBase(ob) {
    this.organizationBase = ob;
    return app.render();
  }

  setExicCard(ob) {
    this.exicCard = ob;
    return app.render();
  }

  setExicCardId(value) {
    this.exicCardId = value;
    return app.render();
  }

  setBusinessEkinetAccountId(value) {
    this.businessEkinetAccountId = value;
    return app.render();
  }

  setDepartment(d) {
    this.department = d;
    return app.render();
  }

  setEmploymentStatus(value) {
    this.employment_status = value;
    return app.render();
  }

  setOrganizationRoleId(value) {
    this.organizationRoleId = value;
    return app.render();
  }

  setGradeId(value) {
    this.gradeId = value;
    return app.render();
  }

  setBrowsingScope(value) {
    this.browsing_scope = value;
    return app.render();
  }

  setShowOtherMembers(value) {
    this.show_other_members = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setShowHotelOfOverLimit(value) {
    this.show_hotel_of_over_limit = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setShowForeignHotelOfOverLimit(value) {
    this.show_foreign_hotel_of_over_limit = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setItineraryApprover(value) {
    this.itinerary_approver = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setDisabled(value) {
    this.disabled = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setSp(value) {
    this.sp = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  setSupportAccount(value) {
    this.supportAccount = typeof value === 'string' ? value === 'true' : value;
    return app.render();
  }

  addTeiki() {
    this.teiki = new Teiki();
    return app.render();
  }

  removeTeiki() {
    if (this.teiki) {
      return this.teiki.remove();
    }
  }

  teikiToDisplay() {
    if (this.teiki && !this.teiki.isRemoved()) {
      return this.teiki;
    }
  }

  addMileageNumber() {
    this.mileageNumbers.push({ carrier: 'ANA', number: '' });
    return app.render();
  }

  removeMileageNumber(index) {
    this.mileageNumbers = this.mileageNumbers.filter((m, i) => i !== index);
    return app.render();
  }

  setMilageCarrier(index, value) {
    this.mileageNumbers[index].carrier = value;
    return app.render();
  }

  setMilageNumber(index, value) {
    this.mileageNumbers[index].number = value;
    return app.render();
  }

  setMileageNumbers(value) {
    this.mileageNumbers = value;
    return app.render();
  }

  setBrowsingDepartments(value) {
    this.browsingDepartments = value;
    return app.render();
  }

  setSignInMethod(value) {
    this.signInMethod = value;
    return app.render();
  }

  setExicId(value) {
    this.exicId = value;
    return app.render();
  }

  setExicPassword(value) {
    this.exicPassword = value;
    return app.render();
  }

  setPassportNumber(value) {
    this.passportNumber = value;
    return app.render();
  }

  setPassportExpire(value) {
    this.passportExpire = value;
    return app.render();
  }

  setExicReferenceNumber(value) {
    this.exicReferenceNumber = value;
    return app.render();
  }

  setAicalendarAvailable(value) {
    this.aicalendarAvailable = value;
    return app.render();
  }

  setAicalendarAdmin(value) {
    this.aicalendarAdmin = value;
    return app.render();
  }

  setIgnoreIpAddressRestriction(value) {
    this.ignoreIpAddressRestriction = value;
    return app.render();
  }

  setAcceptedChatbotTerms(value) {
    this.acceptedChatbotTerms = value;
    return app.render();
  }

  userForwardedEmailsParams() {
    const params = [];
    _.map(this.userForwardedEmails, function (userForwardedEmail, i) {
      if (userForwardedEmail.email) {
        return (params[i] = userForwardedEmail.params());
      }
    });
    return params;
  }

  invitationAcceptParams() {
    const params = {
      last_name: this.lastName,
      first_name: this.firstName,
      last_name_roman: this.lastNameRoman,
      first_name_roman: this.firstNameRoman,
      last_name_kana: this.lastNameKana,
      first_name_kana: this.firstNameKana,
      birthday: this.birthday,
      gender: this.gender,
      tel: this.tel,
      mileage_numbers_attributes: this.mileageNumbers,
      password: this.password,
      nationality_id: this.nationalityId,
      user_forwarded_emails_attributes: this.userForwardedEmailsParams()
    };
    return params;
  }

  insufficientAcceptParams() {
    const params = {
      last_name: this.lastName,
      first_name: this.firstName,
      last_name_roman: this.lastNameRoman,
      first_name_roman: this.firstNameRoman,
      last_name_kana: this.lastNameKana,
      first_name_kana: this.firstNameKana,
      birthday: this.birthday,
      gender: this.gender,
      tel: this.tel,
      mileage_numbers_attributes: this.mileageNumbers,
      nationality_id: this.nationalityId,
      user_forwarded_emails_attributes: this.userForwardedEmailsParams()
    };
    return params;
  }

  updateParams() {
    const params = {
      employee_number: this.employee_number,
      last_name: this.last_name,
      first_name: this.first_name,
      last_name_roman: this.last_name_roman,
      first_name_roman: this.first_name_roman,
      last_name_kana: this.last_name_kana,
      first_name_kana: this.first_name_kana,
      gender: this.gender,
      birthday: this.birthday,
      email: this.email,
      tel: this.tel,
      grade_id: this.gradeId,
      exic_card_id: this.exicCardId,
      business_ekinet_account_id: this.businessEkinetAccountId,
      domestic_approval_required: this.domestic_approval_required,
      foreign_approval_required: this.foreign_approval_required,
      domestic_notification_required: this.domestic_notification_required,
      foreign_notification_requires: this.foreign_notification_requires,
      organization_base_id: this.organizationBaseId(),
      department_id: this.departmentId(),
      employment_status: this.employment_status,
      organization_role_id: this.organizationRoleId,
      browsing_scope: this.browsing_scope,
      show_other_members: this.show_other_members,
      show_hotel_of_over_limit: this.show_hotel_of_over_limit,
      show_foreign_hotel_of_over_limit: this.show_foreign_hotel_of_over_limit,
      itinerary_approver: this.itinerary_approver,
      disabled: this.disabled,
      mileage_numbers_attributes: this.mileageNumbers,
      sign_in_method: this.signInMethod,
      exic_id: this.exicId,
      exic_password: this.exicPassword,
      aicalendar_available: this.aicalendarAvailable,
      aicalendar_admin: this.aicalendarAdmin,
      ignore_ip_address_restriction: this.ignoreIpAddressRestriction,
      admin_notification: this.adminNotification,
      sp: this.sp,
      support_account: this.supportAccount,
      exic_reference_number: this.exicReferenceNumber
    };
    params['browsing_departments_attributes'] = this.browsingDepartments;
    if (this.teiki) {
      params['teiki_attributes'] = this.teiki.params();
    }
    params['user_forwarded_emails_attributes'] = this.userForwardedEmailsParams();
    if (this.remittanceDestinationAccount) {
      params['remittance_destination_account_attributes'] = this.remittanceDestinationAccount.submitParams();
    }
    return params;
  }

  setAutoSyncTripToCalendar(value) {
    this.autoSyncTripToCalendar = value;
    return app.render();
  }
}

module.exports = User;
